export const PRODUCTS_LOADING = 'PRODUCTS_LOADING'
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS'
export const GET_ONE_REGION_PRODUCTS = 'GET_ONE_REGION_PRODUCTS'
export const GET_ONE_PRODUCT = 'GET_ONE_PRODUCT'
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS'
